import {
    sendMessageApp,
    setUrlQuery
} from '@/utils/utils';

// 用于判断接口返回成功的常量
export const SUCCESS_CODE = '0';

// 判断是否是默认地址 1表示是，0表示不是
export const DEFAULT_ADDRESS = 1;

// 支付页用户身份的映射
export const IDENTITY_MAP:any = {
    // 未开通权益
    0: {
        canClick: true,
        className: '',
    },
    // 周卡、月卡、双周卡
    1: {
        canClick: true,
        className: '',
    },
    // 终身卡
    2: {
        canClick: false,
        className: 'btn-gray',
    },
    // 年卡、双年卡
    3: {
        canClick: true,
        className: '',
    },
    // 续费半年卡、续费年卡(只有兑换码)
    4: {
        canClick: true,
        className: '',
    }
};

// 商城&&搭售三个通用弹窗内容
export const MALL_DIALOG_CONTENT = {
    // 【物流弹窗】
    LOGISTICS: {
        type: 'logistics',
        title: '恭喜您购买成功！',
        content: '请您填写收货地址<br>将在7个工作日发出',
        text: '立即填写',
        fn(isPad:any) {
            sendMessageApp('jumpPage', JSON.stringify({
                jumpType: 1,
                // 打开的 webview 是否横屏
                isLandscape: !!isPad,
                // 原页面是否为竖屏
                needPortraitWhenDisappear: !isPad,
                h5Url: setUrlQuery({
                    url: 'my-pages/index.html#/orderlist?tab=2',
                    query: {}
                }),
                isCloseCurPage: true
            }));
        }
    },
    // 【领取弹窗】
    RECEIVE: {
        type: 'receive',
        title: '恭喜您购买成功！',
        content: '请您前往购买记录中查看/激活相关权益',
        text: '立即领取',
        fn(isPad:any) {
            sendMessageApp('jumpPage', JSON.stringify({
                jumpType: 1,
                // 打开的 webview 是否横屏
                isLandscape: !!isPad,
                // 原页面是否为竖屏
                needPortraitWhenDisappear: !isPad,
                h5Url: setUrlQuery({
                    url: 'my-pages/index.html#/orderlist?tab=1',
                    query: {}
                }),
                isCloseCurPage: true
            }));
        }
    },
    // 【通用弹窗】
    COMMON: {
        type: 'common',
        title: '恭喜您购买成功！',
        content: '请您填写收货地址<br>在购买记录中激活相关权益',
        text: '立即领取',
        fn(isPad:any) {
            sendMessageApp('jumpPage', JSON.stringify({
                jumpType: 1,
                // 打开的 webview 是否横屏
                isLandscape: !!isPad,
                // 原页面是否为竖屏
                needPortraitWhenDisappear: !isPad,
                h5Url: setUrlQuery({
                    url: 'my-pages/index.html#/orderlist?tab=2',
                    query: {}
                }),
                isCloseCurPage: true
            }));
        }
    }
};

export const COURSE_TYPE = {
    1: {
        name: '古诗课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '学会古诗',
                unit: '首'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    // 小早英语课
    8: {
        name: '小早英语课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'picbookNum',
                desc: '新读绘本',
                unit: '本'
            },
            {
                key: 'wordsNum',
                desc: '新学单词',
                unit: '个'
            }
        ],
    },
    29: {
        name: '复习课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '阅读字数',
                unit: '字'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    13: {
        name: '成语课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '学会成语',
                unit: '个'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    25: {
        name: '历史课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '阅读字数',
                unit: '字'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    26: {
        name: '小古文课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '阅读字数',
                unit: '字'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    30: {
        name: '表达课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '阅读字数',
                unit: '字'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    12: {
        name: '拼音课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '学习拼音',
                unit: '节'
            },
            {
                key: 'interactiveNum',
                desc: '开口表达',
                unit: '次'
            }
        ],
    },
    35: {
        name: '绘本精讲课—阅读课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '学会单词',
                unit: '个'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ],
    },
    36: {
        name: '中教课',
        desc: [
            {
                key: 'classPerformanceLevel',
                desc: '课堂表现',
                unit: ''
            },
            {
                key: 'interactNum',
                desc: '开口次数',
                unit: '次'
            },
            {
                key: 'interactTimeDuration',
                desc: '上课时长',
                unit: '分钟'
            }
        ],
    },
    37: {
        name: '外教课',
        desc: [
            {
                key: 'classPerformanceLevel',
                desc: '课堂表现',
                unit: ''
            },
            {
                key: 'interactNum',
                desc: '开口次数',
                unit: '次'
            },
            {
                key: 'interactTimeDuration',
                desc: '上课时长',
                unit: '分钟'
            }
        ]
    },
    38: {
        name: '绘本精讲课—英语课',
        desc: [
            {
                key: 'learnDays',
                desc: '坚持学习',
                unit: '天'
            },
            {
                key: 'totalNum',
                desc: '学会单词',
                unit: '个'
            },
            {
                key: 'interactiveNum',
                desc: '互动开口',
                unit: '次'
            }
        ]
    },
    31: {
        name: '私教课',
        desc: [
            {
                key: 'classPerformanceLevel',
                desc: '课堂表现',
                unit: ''
            },
            {
                key: 'interactNum',
                desc: '开口次数',
                unit: '次'
            },
            {
                key: 'interactTimeDuration',
                desc: '上课时长',
                unit: '分钟'
            }
        ]
    }
};
